import { dashboardGql } from '../../../data/gql-gen/dashboard'

export const IMPORT_SOURCE_WAVE = dashboardGql(/* GraphQL */ `
  query importSourceWave($surveyId: ID!) {
    waveBySurveyId(surveyId: $surveyId) {
      waveId
    }
  }
`)
